<template>
  <el-container>
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="workCenters"
          @delete="deleteHandle"
          @addOrEdit="addEditHandle"
          @select="selectHandle"
          @reset="resetHandle">
        <template slot="otherBtn">
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除 </el-button>
        </template>
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
            <el-form-item label="中心编号">
              <el-input v-model.trim="filter.workCenterNo" placeholder="请输入中心编号" clearable/>
            </el-form-item>
            <el-form-item label="中心名称">
              <el-input v-model.trim="filter.workCenterName" placeholder="请输入中心名称" clearable/>
            </el-form-item>
            <el-form-item label="所属车间">
              <el-input v-model.trim="filter.workshopName" placeholder="请输入所属车间名称" clearable/>
            </el-form-item>
            <el-form-item label="生产类型">
              <el-select v-model="filter.productionType" clearable placeholder="请选择生产类型">
                <el-option v-for="(item, index) in productionTypeList" :key="index" :label="item.name" :value="item.code"/>
              </el-select>
            </el-form-item>
            <!--            <el-form-item label="载具绑定类型">-->
            <!--              <el-select v-model="filter.bindVehicleType" clearable placeholder="请选择载具绑定类型">-->
            <!--                <el-option v-for="(item, index) in bindVehicleTypeList" :key="index" :label="item.name" :value="item.code"/>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
          </el-form>
        </template>
        <el-table-column type="selection" align="center" width="55" prop="selection"/>
        <el-table-column prop="workCenterNo" align="center" label="中心编号" width="100"/>
        <el-table-column prop="workCenterName" align="left" show-overflow-tooltip label="中心名称"/>
        <el-table-column prop="productionTypeName" align="center" label="生产类型" width="100"/>
        <el-table-column prop="bindVehicleTypeName" align="center" label="载具绑定" width="100"/>
        <el-table-column prop="isLoadMaterial" align="center" label="上料认证" width="100">
          <template v-slot="scope">
            <span v-if="scope.row.isLoadMaterial">需要</span>
            <span v-else>不需要</span>
          </template>
        </el-table-column>
        <el-table-column prop="workshopName" align="left" show-overflow-tooltip label="所属车间"/>
        <el-table-column prop="locationName" align="center" show-overflow-tooltip label="边线库"/>
        <el-table-column prop="creatorName" align="center" label="创建人" width="120"/>
        <el-table-column prop="createTime" align="center" label="创建时间" width="150"/>
        <el-table-column
            label="操作"
            align="center"
            width="120px"
            prop="action"
            fixed="right">
          <template slot-scope="scope">
            <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open(scope.row.pkId)"> 编辑 </el-button>
            <el-button v-if="delAuth" type="danger" @click="deleteRow(scope.row.pkId)"> 删除 </el-button>
          </template>
        </el-table-column>
      </view-table>
      <work-center-edit ref="editPage" :production-type-list="productionTypeList" :bind-vehicle-type-list="bindVehicleTypeList" @save-success="loadData(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import WorkCenterEdit from "@/views/information/WorkCenter/WorkCenterEdit";

  export default {
    name: "WorkCenterList",
    components: { WorkCenterEdit, ViewTable},
    data() {
      return {
        limits:{
          addAuth: this.$auth(175),
          editAuth: this.$auth(177),
          delAuth: this.$auth(178),
        },
        delAllAuth: this.$auth(176),
        selection: [],
        filter: {
          workCenterNo:"",
          workCenterName:"",
          workshopName:"",
          productionType:"",
          bindVehicleType:"",
        },
        productionTypeList: [],
        bindVehicleTypeList: [],
        columnsProperty:[
          {
            key:"workCenterNo",
            align:"center",
            width:120,
          },
          {
            key:"workCenterName",
            align:"left",
          },
          {
            key:"productionTypeName",
            align:"left",
          },
          // {
          //   key:"bindVehicleTypeName",
          //   align:"left",
          // },
          // {
          //   key:"isLoadMaterial",
          //   align:"center",
          // },
          {
            key:"workshopName",
            align:"left",
          },
          // {
          //   key:"locationName",
          //   align:"center",
          // },
          {
            key:"creatorName",
            align:"center",
            width:120,
          },
          {
            key:"createTime",
            align:"center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
      this.getProductionTypeDict();
      this.getBindVehicleTypeDict();
    },
    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      // 单个删除
      deleteHandle(row) {
        this.$http.delete("basic", "workCenters", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      // 批量删除
      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkId);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "workCenters/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      //生产类型字典
      getProductionTypeDict() {
        this.$http.get("basic", "dictionaries/dictEnum/ProdType").then((resp) => {
          if (resp.success) {
            this.productionTypeList = resp.data;
          }
        });
      },

      //载具选择字典
      getBindVehicleTypeDict() {
        this.$http.get("basic", "dictionaries/dictEnum/BindVehicleType").then((resp) => {
          if (resp.success) {
            this.bindVehicleTypeList = resp.data;
          }
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
